import { slideUp, slideDown } from 'es6-slide-up-down';
import svg from '!!raw-loader!../../assets/svg/accordion-arrow.svg';

const inlineSvg = () => {
    const helper = document.createElement('div');

    helper.innerHTML = svg;

    return helper.firstChild;
};

class AccordionItem {
    private timer: number;

    constructor(
        public trigger: HTMLElement,
        public button: HTMLElement,
        public body: HTMLElement,
        expanded: Boolean = false
    ) {
        if (!expanded) this.hide(0);
        else this.button.setAttribute('aria-expanded', 'true');

        this.button.appendChild(inlineSvg());
    }

    show(duration = 300) {
        clearInterval(this.timer);
        this.button.setAttribute('aria-expanded', 'true');

        this.body.removeAttribute('hidden');
        slideDown(this.body, duration);
    }

    hide(duration = 300) {
        this.button.setAttribute('aria-expanded', 'false');

        if (duration !== 0) {
            slideUp(this.body, duration);
            this.timer = window.setTimeout(() => {
                this.body.setAttribute('hidden', '');
            }, duration);
        } else {
            this.body.setAttribute('hidden', '');
        }
    }

    toggle() {
        if (this.isHidden()) {
            this.show();
        } else {
            this.hide();
        }
    }

    isHidden() {
        return this.button.getAttribute('aria-expanded') === 'false';
    }
}

export default class Accordion {
    private pairs: AccordionItem[] = [];
    private singleElement: Boolean;
    private expanded: Boolean;

    constructor(private root: HTMLElement) {
        this.init();
    }

    init() {
        const triggers = Array.from(
            this.root.querySelectorAll('[data-accordion-toggle]')
        ).filter((trigger) => trigger.parentElement == this.root);

        this.singleElement = this.root.dataset.accordionSingle === 'true';
        this.expanded = this.root.dataset.accordionExpanded === 'true';

        triggers.forEach((trigger: HTMLElement) => this.addChild(trigger));
    }

    addChild(trigger: HTMLElement) {
        const target = trigger.dataset.accordionToggle;
        const button = trigger.querySelector('button');
        const body = document.getElementById(target);

        if (!body || !button) return;

        const pair = new AccordionItem(
            trigger,
            button,
            body,
            this.expanded || trigger.hasAttribute('data-expanded')
        );

        this.pairs.push(pair);

        trigger.addEventListener('click', () => this.toggleChild(pair));
    }

    toggleChild(pair: AccordionItem) {
        if (pair.isHidden() && this.singleElement) {
            this.pairs
                .filter((x) => x !== pair)
                .forEach((x: AccordionItem) => {
                    if (!x.isHidden()) x.hide();
                });
        }

        pair.toggle();
    }
}
